import type { LuckFactor } from "./luck";
import { scoreOutOf100Label } from "./score-display";

export function formatLuckDelta(delta: number): { sign: string; absDelta: number; label: string } {
  const absDelta = Math.abs(delta);
  const sign = delta >= 0 ? "+" : "−";
  return { sign, absDelta, label: `${sign}${absDelta.toFixed(1)} vs typical` };
}

/** Delta → hex colour (matches the legacy LuckGauge thresholds). */
export function luckDeltaColour(delta: number): string {
  if (delta >= 1) return "#059669";
  if (delta >= 0.3) return "#65a30d";
  if (delta >= -0.3) return "#d97706";
  if (delta >= -1) return "#ea580c";
  return "#dc2626";
}

/** One unified rule for "is there a luck story worth a chip?" — replaces the
 *  two divergent per-page card gates. */
export function shouldShowLuckChip(luck: LuckFactor | null): boolean {
  if (!luck || luck.weekLabel === "") return false;
  return Math.abs(luck.delta) >= 0.3 || luck.drivers.length > 0 || luck.bullets.length > 0;
}

export function formatLuckTypical(luck: LuckFactor): string {
  return `Typical ${scoreOutOf100Label(luck.typicalScore)} for ${luck.weekLabel}`;
}
